/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_Lower_ThirdInputs */

const en_ocr_crop_lower_third = /** @type {(inputs: Ocr_Crop_Lower_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lower Third (Recommended)`)
};

const fr_ocr_crop_lower_third = /** @type {(inputs: Ocr_Crop_Lower_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiers inférieur (recommandé)`)
};

const de_ocr_crop_lower_third = /** @type {(inputs: Ocr_Crop_Lower_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untere Drittel-Einblendung (Empfohlen)`)
};

const it_ocr_crop_lower_third = /** @type {(inputs: Ocr_Crop_Lower_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In basso (consigliato)`)
};

const ru_ocr_crop_lower_third = /** @type {(inputs: Ocr_Crop_Lower_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нижняя треть (рекомендуется)`)
};

const es_ocr_crop_lower_third = /** @type {(inputs: Ocr_Crop_Lower_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tercio inferior (recomendado)`)
};

const zh_cn2_ocr_crop_lower_third = /** @type {(inputs: Ocr_Crop_Lower_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下方三分之一（推荐）`)
};

const ja_ocr_crop_lower_third = /** @type {(inputs: Ocr_Crop_Lower_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下部3分の1（推奨）`)
};

const hi_ocr_crop_lower_third = /** @type {(inputs: Ocr_Crop_Lower_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निचला तीसरा भाग (अनुशंसित)`)
};

const pt_pt2_ocr_crop_lower_third = /** @type {(inputs: Ocr_Crop_Lower_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terço inferior (recomendado)`)
};

/**
* | output |
* | --- |
* | "Lower Third (Recommended)" |
*
* @param {Ocr_Crop_Lower_ThirdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_lower_third = /** @type {((inputs?: Ocr_Crop_Lower_ThirdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_Lower_ThirdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_crop_lower_third(inputs)
	if (locale === "de") return de_ocr_crop_lower_third(inputs)
	if (locale === "it") return it_ocr_crop_lower_third(inputs)
	if (locale === "ru") return ru_ocr_crop_lower_third(inputs)
	if (locale === "es") return es_ocr_crop_lower_third(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_crop_lower_third(inputs)
	if (locale === "ja") return ja_ocr_crop_lower_third(inputs)
	if (locale === "hi") return hi_ocr_crop_lower_third(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_crop_lower_third(inputs)
	return en_ocr_crop_lower_third(inputs)
});